import { render, staticRenderFns } from "./InvitationsTable.vue?vue&type=template&id=59ad7430&scoped=true&"
import script from "./InvitationsTable.vue?vue&type=script&lang=js&"
export * from "./InvitationsTable.vue?vue&type=script&lang=js&"
import style0 from "./InvitationsTable.vue?vue&type=style&index=0&id=59ad7430&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59ad7430",
  null
  
)

export default component.exports